/* Garde d'idempotence : selon le noeud CDN, ce code arrive soit inline dans la section,
   soit par le fichier asset. Les deux peuvent charger — seul le premier s'initialise. */
if (!window.__vyrCartInit) {
  window.__vyrCartInit = true;

  (function () {
    var LOCK = 'vyrc-locked';
    var KEY = 'vyrCartUntil';
    var SPAN = 10 * 60 * 1000;
    var refreshing = false;
    var memo = 0; /* repli quand sessionStorage est bloqué (Safari navigation privée) */

    function readUntil() {
      try { return parseInt(window.sessionStorage.getItem(KEY) || '0', 10); }
      catch (e) { return memo; }
    }

    function writeUntil(v) {
      memo = v;
      try { window.sessionStorage.setItem(KEY, String(v)); } catch (e) {}
    }


    /* Un pack de N unités part en N lignes distinctes de la variante à l'unité.
       C'est ce qui donne N produits au checkout et déclenche la remise automatique
       Shopify du palier, visible dans le panier. */
    function multiPack(form) {
      try {
        var checked = form.querySelector('[data-vyr-packs] input[type="radio"]:checked');
        if (!checked) return null;
        var label = checked.closest('[data-vyr-pack]');
        var units = parseInt(label && label.getAttribute('data-vyr-units'), 10) || 1;
        if (units < 2) return null;

        var mapEl = form.querySelector('[data-vyr-unitmap]');
        if (!mapEl) return null;
        var map = JSON.parse(mapEl.textContent);

        var rows = label.querySelectorAll('.vyr-pack__sizerow');
        var items = [];
        for (var i = 0; i < rows.length; i++) {
          var color = rows[i].querySelector('.vyr-select--color');
          var selects = rows[i].querySelectorAll('.vyr-select');
          var size = selects[selects.length - 1];
          var key = (color ? color.value : '') + '||' + (size ? size.value : '');
          var id = map[key];
          if (!id) return null; /* combinaison inconnue : on retombe sur le comportement normal */
          items.push({ id: id, quantity: 1 });
        }
        return items.length === units ? { items: items } : null;
      } catch (err) {
        return null;
      }
    }

    function root() { return document.querySelector('[data-vyrc]'); }

    /* A/B d'offres (contrat ~/Developer/vyran-ab/SPEC.md) : le tiroir est sur toutes les pages,
       la buy box non. Il relit donc l'offre dans le navigateur (écrite par la buy box) pour
       rattraper un panier sans étiquette et pour la balise « checkout ». Rien de bloquant. */
    function abCtx() {
      try {
        var cfg = JSON.parse(window.localStorage.getItem('vyr_ab_cfg') || 'null');
        if (!cfg || !cfg.on || !cfg.test) return null;
        var force = null;
        try { force = window.sessionStorage.getItem('vyr_ab_force'); } catch (e) {}
        if (!/^[ABC]$/.test(force || '')) force = null;
        var arm = force || window.localStorage.getItem('vyr_ab:' + cfg.test);
        var vid = window.localStorage.getItem('vyr_vid');
        if (!/^[ABC]$/.test(arm || '') || !/^[a-f0-9]{32}$/.test(vid || '')) return null;
        var qa = !!force || window.localStorage.getItem('vyr_ab_off') === '1';
        return { test: cfg.test, ep: cfg.ep, arm: arm, vid: vid, qa: qa };
      } catch (e) { return null; }
    }

    function abBeacon(t) {
      var c = abCtx();
      if (!c || !c.ep) return;
      try {
        var body = JSON.stringify({ v: 1, t: t, test: c.test, arm: c.arm, vid: c.vid, u: 0, qa: c.qa ? 1 : 0 });
        var url = String(c.ep).replace(/\/+$/, '') + '/e';
        if (navigator.sendBeacon && navigator.sendBeacon(url, body)) return;
        fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function () {});
      } catch (e) {}
    }

    /* A/B v2 — le guide offert suit l'état du panier, comme le « free gift » d'une app de bundle.
       Règle : offre B ou C (attribut du panier) et au moins 2 tubes ⇒ exactement UNE ligne porte la
       propriété GIFT_KEY (c'est elle que le checkout affiche). Sinon aucune.
       Une passe = on relit le panier, on corrige UNE chose, on relit : Shopify fusionne les lignes
       identiques et renumérote, donc jamais deux écritures sur un état lu une seule fois. */
    var GIFT_KEY = 'Free guide';
    /* Test 2 VYRAN (08/10/2026) : en offre B, 2 tubes = « 1 + 1 » au prix d'un tube. Ce prix vient d'un code
       réservé à l'offre B, posé sur le panier à 2 tubes pile (à 4 et 6 tubes, l'escalier automatique fait le prix)
       et retiré dans tous les autres cas ; le code que le client avait saisi lui est rendu à ce moment-là.
       A/B coupé (défaut) : rien de tout cela ne tourne. */
    var OFFER_CODE = '1PLUS1FREE';
    var GIFT_VAL = 'Free digital guide';
    var syncing = null;

    function isCream(it) {
      return !!it && ((it.sku && String(it.sku).indexOf('VYR-DC-') === 0) || /density cream/i.test(it.product_title || ''));
    }

    function cartJson() {
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
    }

    function post(url, data) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(data)
      }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
    }

    /* Shopify ignore « properties: {} » : une propriété ne s'enlève qu'en vidant sa valeur. Une
       valeur vide ne s'affiche ni au panier ni au checkout, et ne compte pas comme cadeau ici. */
    function withGift(props, on) {
      var out = {};
      Object.keys(props || {}).forEach(function (k) { out[k] = props[k]; });
      out[GIFT_KEY] = on ? GIFT_VAL : '';
      return out;
    }

    function sig(cart) {
      return (cart.items || []).map(function (it) {
        return it.key + ':' + it.quantity + ':' + (it.properties && it.properties[GIFT_KEY] ? 1 : 0);
      }).join('|') + '|' + ((cart.attributes || {})._vyr_ab || '') + '|' + (cart.discount_codes || []).map(function (d) {
        return d.code + (d.applicable ? '+' : '-');
      }).join(',');
    }

    /* Une seule correction par appel ; renvoie true si le panier a changé. */
    function syncStep(cart, c) {
      if (!cart || !cart.item_count) return Promise.resolve(false);
      var a = cart.attributes || {};
      if (c && !(a._vyr_ab && a._vyr_test === c.test)) {
        return post('/cart/update.js', { attributes: { _vyr_ab: c.arm, _vyr_test: c.test, _vyr_qa: c.qa ? '1' : '' } })
          .then(function () { return true; });
      }
      var arm = a._vyr_ab, n = 0, cream = [], gifted = [];
      cart.items.forEach(function (it) {
        if (!isCream(it)) return;
        n += it.quantity; cream.push(it);
        if (it.properties && it.properties[GIFT_KEY]) gifted.push(it);
      });
      /* Test 2 (08/10/2026) : le guide offert est retiré de toutes les offres. La passe ne fait plus
         qu'enlever la propriété des paniers qui la portent encore. */
      var rule = false;
      var fix = null, on = false;
      if (rule && !gifted.length) { fix = cream[0]; on = true; }
      else if (rule && gifted.length > 1) { fix = gifted[1]; }
      else if (!rule && gifted.length) { fix = gifted[0]; }
      if (fix) {
        return post('/cart/change.js', { id: fix.key, quantity: fix.quantity, properties: withGift(fix.properties, on) })
          .then(function () { return true; });
      }
      var codes = (cart.discount_codes || []).map(function (d) { return String(d.code || ''); });
      var ours = codes.filter(function (x) { return x.toUpperCase() === OFFER_CODE; });
      /* Test 3 (09/10/2026) : « 1 + 1 » existe en B et en C (C = 1 tube / 1 + 1, sans 2 + 2). */
      var want = n === 2 && ((a._vyr_test === 'offre2' && arm === 'B') || (a._vyr_test === 'offre3' && (arm === 'B' || arm === 'C')));
      /* À 2 tubes, OFFER_CODE (−50 %) bat tous les codes client (10 à 20 %) : on le pose à la place du
         code saisi (sinon le client paierait plus que le prix affiché), et on lui rend ce code dès que
         le panier quitte les 2 tubes. */
      if (want && !ours.length) {
        if (codes.length) { try { window.sessionStorage.setItem('vyr_prev_codes', codes.join(',')); } catch (e) {} }
        return post('/cart/update.js', { discount: OFFER_CODE }).then(function () { return true; });
      }
      if (!want && ours.length) {
        var keep = codes.filter(function (x) { return x.toUpperCase() !== OFFER_CODE; });
        var prev = '';
        try { prev = window.sessionStorage.getItem('vyr_prev_codes') || ''; window.sessionStorage.removeItem('vyr_prev_codes'); } catch (e) {}
        prev.split(',').forEach(function (x) { if (x && keep.indexOf(x) < 0) keep.push(x); });
        return post('/cart/update.js', { discount: keep.join(',') }).then(function () { return true; });
      }
      return Promise.resolve(false);
    }

    /* Rejoue syncStep jusqu'à un panier stable (6 corrections au plus). Un appel qui arrive
       pendant une passe en cours ne réutilise pas son résultat (calculé sur l'ancien panier) :
       une passe neuve est mise en file derrière elle, une seule. Ne rejette jamais. */
    var queued = null;
    function abSync() {
      if (syncing) {
        if (!queued) queued = syncing.then(function () { queued = null; return runSync(); });
        return queued;
      }
      return runSync();
    }

    function runSync() {
      var c = abCtx(), changed = false, left = 6;
      var prev = null;
      function loop() {
        if (left-- <= 0) return changed;
        return cartJson().then(function (cart) {
          var a = (cart && cart.attributes) || {};
          if (!c && a._vyr_ab !== 'B' && a._vyr_ab !== 'C') return changed; /* rien à régler */
          var s = sig(cart);
          if (s === prev) return changed; /* la dernière écriture n'a rien changé : on s'arrête */
          prev = s;
          return syncStep(cart, c).then(function (did) {
            if (!did) return changed;
            changed = true;
            return loop();
          });
        });
      }
      syncing = loop().catch(function () { return changed; })
        .then(function (ch) { syncing = null; return ch; });
      return syncing;
    }

    /* Après chaque rafraîchissement du tiroir : on réconcilie ; si on a corrigé quelque chose,
       un seul rafraîchissement de plus pour afficher l'état juste (jamais de boucle). */
    var syncHold = false;
    function afterRefresh() {
      if (syncHold) return;
      abSync().then(function (changed) {
        if (!changed) return;
        if (/\/cart\/?$/.test(window.location.pathname)) {
          /* page /cart (rendue par Horizon, pas par le tiroir) : on la recharge, une fois par 10 s au plus */
          var last = 0;
          try { last = parseInt(window.sessionStorage.getItem('vyr_ab_rl') || '0', 10); } catch (e) {}
          if (Date.now() - last > 10000) {
            try { window.sessionStorage.setItem('vyr_ab_rl', String(Date.now())); } catch (e) {}
            window.location.reload();
            return;
          }
        }
        syncHold = true;
        return refresh(false).then(function () { syncHold = false; }, function () { syncHold = false; });
      }).catch(function () {});
    }

    function open() {
      var r = root();
      if (!r) return;
      r.hidden = false;
      document.body.classList.add(LOCK);
      window.setTimeout(function () {
        var cur = root();
        if (cur) cur.classList.add('is-open');
      }, 10);
    }

    function close() {
      var r = root();
      if (!r) return;
      r.classList.remove('is-open');
      document.body.classList.remove(LOCK);
      window.setTimeout(function () {
        var cur = root();
        if (cur && !cur.classList.contains('is-open')) cur.hidden = true;
      }, 260);
    }

    function tick() {
      var el = document.querySelector('[data-vyrc-clock]');
      if (!el) return;
      var until = readUntil();
      if (!until || until < Date.now()) {
        until = Date.now() + SPAN;
        writeUntil(until);
      }
      var left = Math.max(0, until - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    window.setInterval(function () { try { tick(); } catch (e) {} }, 1000);

    /* On ne touche jamais au contenu de cart-icon : Horizon y attend un ref nommé et
       l'écraser fait planter tout son système de composants, donc l'ajout au panier.
       On remplace l'élément entier par celui du rendu serveur, refs compris. */
    function syncCount(doc) {
      try {
        var fresh = doc.querySelector('cart-icon');
        var cur = document.querySelector('cart-icon');
        if (fresh && cur) cur.replaceWith(fresh.cloneNode(true));
      } catch (e) {}
    }

    function refresh(thenOpen) {
      if (refreshing) {
        if (thenOpen) open();
        return Promise.resolve();
      }
      refreshing = true;
      return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-vyrc]');
          var cur = root();
          if (next && cur) {
            var wasOpen = cur.classList.contains('is-open');
            next.hidden = wasOpen ? false : cur.hidden;
            if (wasOpen) next.classList.add('is-open');
            cur.replaceWith(next);
          }
          syncCount(doc);
          tick();
          if (thenOpen) open();
        })
        .catch(function () { if (thenOpen) open(); })
        .then(function () { refreshing = false; try { afterRefresh(); } catch (e) {} });
    }

    /* Le bouton panier de Horizon n'est pas un lien : c'est un <button aria-label="Cart">
       câblé sur son propre drawer, que nous avons supprimé. On l'attrape par tous ses signes. */
    function cartTrigger(target) {
      var t = target.closest('a[href$="/cart"], a[href*="/cart?"], [aria-label="Cart"], [data-testid="cart-icon"]');
      if (t) return t;
      var icon = target.closest('cart-icon');
      if (icon) return icon.closest('button, a') || icon;
      /* Horizon enveloppe <cart-icon> dans un <button> : un clic sur la marge du bouton
         ne remonte à rien par closest(). Au doigt, la marge est l'essentiel de la cible. */
      var btn = target.closest('button, a');
      if (btn && btn.querySelector('cart-icon')) return btn;
      return null;
    }

    document.addEventListener('click', function (e) {
      try {
        if (e.target.closest('[data-vyrc-close]')) {
          e.preventDefault();
          close();
          return;
        }

        if (root() && cartTrigger(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          open();
          return;
        }

        var atc = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button:not([type])');
        if (atc) {
          var form = atc.closest('form');
          e.preventDefault();
          e.stopPropagation();
          atc.setAttribute('aria-busy', 'true');
          var payload = multiPack(form);
          var req = payload
            ? fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(payload)
              })
            : fetch('/cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
          req.then(function (r) { return r.json(); })
            .then(function () { return refresh(true); })
            .catch(function () {})
            .then(function () { atc.removeAttribute('aria-busy'); });
          return;
        }

        var step = e.target.closest('[data-vyr-qty]');
        if (step) {
          e.preventDefault();
          e.stopPropagation();
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              line: parseInt(step.dataset.vyrQty, 10),
              quantity: parseInt(step.dataset.vyrTo, 10)
            })
          }).then(function () { return refresh(false); }).catch(function () {});
        }
      } catch (err) {
        /* jamais bloquer le clic à cause d'une erreur de notre côté */
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Retour arrière / avant : le navigateur ressert la page depuis son cache (bfcache), avec le
       tiroir tel qu'il était — lignes, total et guide offert d'un autre moment. En offre B ou C,
       on le redessine (et la réconciliation suit). Offre A : comportement du live, inchangé. */
    window.addEventListener('pageshow', function (e) {
      try {
        if (!e || !e.persisted) return;
        var c = abCtx();
        if (!c || (c.arm !== 'B' && c.arm !== 'C')) return;
        refresh(false);
      } catch (err) {}
    });

    /* Page /cart (Horizon) : ses changements de quantité passent par ses propres composants et
       annoncent « shopify:cart:lines-update » avec une promesse ; on réconcilie une fois la
       modification terminée. Le tiroir, lui, réconcilie déjà après chaque rafraîchissement. */
    document.addEventListener('shopify:cart:lines-update', function (e) {
      try {
        var run = function () { window.setTimeout(function () { try { afterRefresh(); } catch (err) {} }, 150); };
        if (e && e.promise && e.promise.then) e.promise.then(run, run);
        else window.setTimeout(run, 1200);
      } catch (err) {}
    });

    /* Clic « Commander » (tiroir ou page /cart) : balise « co ». En offre B ou C seulement, on
       attend la réconciliation du guide (2,5 s au plus) puis on renvoie le même formulaire avec le
       même bouton — le checkout reçoit le panier juste. Offre A : rien n'est retenu, le clic part. */
    document.addEventListener('click', function (e) {
      try {
        var b = e.target.closest && e.target.closest('.vyr-cf__cta, button[name="checkout"], input[name="checkout"]');
        if (!b) return;
        if (b.getAttribute('data-vyr-pass') === '1') { b.removeAttribute('data-vyr-pass'); return; }
        abBeacon('co');
        var c = abCtx();
        var form = b.form || b.closest('form');
        if (!c || (c.arm !== 'B' && c.arm !== 'C') || !form) return;
        /* Rien en cours = le panier est déjà juste : le clic part aussi vite qu'en offre A.
           Retenir chaque clic B/C d'un aller-retour réseau ajouterait une friction que A n'a pas,
           et le test mesurerait ce délai au lieu de l'offre. */
        if (!syncing && !queued) return;
        e.preventDefault();
        e.stopPropagation();
        var done = false;
        var go = function () {
          if (done) return;
          done = true;
          try {
            if (form.requestSubmit) form.requestSubmit(b);
            else { b.setAttribute('data-vyr-pass', '1'); b.click(); }
          } catch (err) { b.setAttribute('data-vyr-pass', '1'); b.click(); }
        };
        window.setTimeout(go, 2500);
        abSync().then(go, go);
      } catch (err) {}
    }, true);

    /* Les sections qui construisent elles-mêmes leur payload (buy box crème) ont besoin
       d'ouvrir le tiroir sans passer par l'interception de formulaire. */
    window.vyrCart = { open: open, close: close, refresh: refresh };

    try { tick(); } catch (e) {}
    try { afterRefresh(); } catch (e) {}
  })();
}
